import localisations from "shell/localisation";

import useStyles from "./styles";

function Footer() {
    const classes = useStyles();
    return <div className={classes.root}>{localisations.components.footer.example}</div>;
}

export default Footer;
